import Api from '@/api/api.js'

// Modèles de certificats médicaux pré-enregistrés (Paramètres › Dossier & Soins, 04/10/2026).
export default {
    liste() {
        return Api().get('/parametres/certificats/modeles').then(response => response.data)
    },
    enregistrer(data) {
        return Api().post('/parametres/certificats/modeles', data).then(response => response.data)
    },
    reordonner(ids) {
        return Api().post('/parametres/certificats/modeles/re-ordonner', { ids }).then(response => response.data)
    },
    retirer(id) {
        return Api().delete('/parametres/certificats/modeles/' + id).then(response => response.data)
    },
}
